import { DRACOLoader } from '../thirdparty/three/imports';

export class DRACOLoader3D
{
    _loader: DRACOLoader;

    constructor()
    {
        this._loader = new DRACOLoader();
    }

    setDecoderPath(path: string)
    {
        this._loader.setDecoderPath(path);

        return this;
    }
}
